import { Link } from 'react-router';
import { PlusIcon } from 'lucide-react';

import { IconLogo } from 'src/components/Svg/Images';
import { Button } from '@/components/ui/button';

type Props = {
  firstName?: string;
};

const WelcomeEmptyState = ({ firstName }: Props) => (
  <div className="sm:mt-[8vh] flex flex-col items-center justify-center px-4 text-center">
    <div className="mb-8 flex size-33 items-center justify-center rounded-xl border border-border bg-white shadow-lg">
      <IconLogo aria-hidden="true" className="size-19" />
    </div>
    <h1 className="text-xl font-extrabold text-foreground">Welcome{firstName && `, ${firstName}`}</h1>
    <p className="mt-2 max-w-116 text-sm leading-6 text-muted-foreground">
      Applications are how Codekeeper protects the software you build and rely on. Create your first one, then attach
      the resilience products that keep it safe.
    </p>
    <Button asChild className="mt-8">
      <Link to="/applications/new">
        <PlusIcon />
        Create your first application
      </Link>
    </Button>
  </div>
);

export default WelcomeEmptyState;
